var map = {
	"./arrow-right.svg": 2,
	"./check.svg": 3,
	"./clock.svg": 4,
	"./close-white.svg": 5,
	"./close.svg": 6,
	"./email.svg": 7,
	"./facebook.svg": 8,
	"./fax.svg": 9,
	"./instagram.svg": 10,
	"./location.svg": 11,
	"./logo-signet.svg": 12,
	"./logo-small.svg": 13,
	"./menu-close.svg": 14,
	"./menu-toggle.svg": 15,
	"./newsletter-send.svg": 16,
	"./phone.svg": 17,
	"./plus.svg": 18,
	"./sample.svg": 19,
	"./scroll-top.svg": 20,
	"./select-box-arrow.svg": 21,
	"./sheep.svg": 22,
	"./shop-link.svg": 23,
	"./slide-button-left.svg": 24,
	"./slide-button-right.svg": 25,
	"./user.svg": 26,
	"./youtube.svg": 27
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;